import { render } from "./ScreenLandscape.vue?vue&type=template&id=c7197ff8&scoped=true"
import script from "./ScreenLandscape.vue?vue&type=script&lang=js"
export * from "./ScreenLandscape.vue?vue&type=script&lang=js"

import "./ScreenLandscape.vue?vue&type=style&index=0&id=c7197ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7197ff8"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
